/** PKCE helpers for the OAuth 2.1 Authorization Code flow against Supabase's OAuth Server. */

function base64UrlEncode(bytes: Uint8Array): string {
  let binary = '';
  for (const byte of bytes) {
    binary += String.fromCharCode(byte);
  }
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

function randomBytes(length: number): Uint8Array {
  const bytes = new Uint8Array(length);
  crypto.getRandomValues(bytes);
  return bytes;
}

/** RFC 7636 code_verifier: 43-128 chars from the unreserved character set. */
export function generateCodeVerifier(): string {
  return base64UrlEncode(randomBytes(64));
}

/** S256 code_challenge derived from a code_verifier. */
export async function generateCodeChallenge(codeVerifier: string): Promise<string> {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(codeVerifier));
  return base64UrlEncode(new Uint8Array(digest));
}

/** Opaque anti-CSRF token round-tripped through the authorization request. */
export function generateState(): string {
  return base64UrlEncode(randomBytes(16));
}
